exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-tabs[data-v-25eb985c]{display:flex;flex-wrap:nowrap;gap:4px;margin-bottom:16px;overflow-x:auto;border-bottom:1px solid #e6e7eb}.pi-tab[data-v-25eb985c]{flex:0 0 auto;padding:10px 14px;border-bottom:2px solid transparent;font-size:13px;font-weight:600;color:#4e5560;text-decoration:none;white-space:nowrap}.pi-tab[data-v-25eb985c]:focus,.pi-tab[data-v-25eb985c]:hover{color:#1d12b9;text-decoration:none}.pi-tab[data-v-25eb985c]:focus{outline:2px solid #1b59f8;outline-offset:-2px}.pi-tab.is-on[data-v-25eb985c]{color:#1d12b9;border-bottom-color:#1d12b9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25eb985c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/pi/piTabs.vue
// module id = 1597
// module chunks = 0